import Vue from 'vue';
import Column from 'primevue/column';

Vue.component('Column', Column);
